"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactSpring = require("react-spring");

var _Popper = _interopRequireDefault(require("../Popper"));

var _Drawer = _interopRequireDefault(require("./Drawer"));

var _useLazyRef = _interopRequireDefault(require("../hooks/useLazyRef"));

var _useAppearTransition = _interopRequireDefault(require("./useAppearTransition"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  return {
    fullHeight: {
      height: '100%',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column'
    }
  };
};
/** Get position to transfer to the underlying Popper component */


var usePosition = function usePosition(position) {
  switch (position) {
    case 'right':
      return {
        vertical: 'center',
        horizontal: 'right'
      };

    case 'left':
      return {
        vertical: 'center',
        horizontal: 'left'
      };

    case 'top':
      return {
        vertical: 'top',
        horizontal: 'center'
      };

    default:
      return {
        vertical: 'bottom',
        horizontal: 'center'
      };
  }
};
/** A customizable SlideableDrawer that can be used in many cases */


var SlideableDrawer = function SlideableDrawer(props) {
  var open = props.open,
      anchorRef = props.anchorRef,
      position = props.position,
      color = props.color,
      elevation = props.elevation,
      borderColor = props.borderColor,
      PopperProps = props.PopperProps,
      _props$appearConfig = props.appearConfig,
      appearConfig = _props$appearConfig === void 0 ? {
    tension: 240,
    friction: 15
  } : _props$appearConfig,
      fullHeight = props.fullHeight,
      children = props.children,
      className = props.className,
      style = props.style;
  var classes = useStyles();
  /** Get default anchorRef which is the `document.body` */

  var defaultAnchorRef = (0, _useLazyRef["default"])(function () {
    if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
      return window.document.body;
    }

    return null;
  });
  /** Use transitions of appearance */

  var transition = (0, _useAppearTransition["default"])(open, position, appearConfig);
  var anchorOrigin = usePosition(position);
  var popperOrigin = usePosition(position);
  return (0, _core.jsx)(_react["default"].Fragment, null, transition.map(function (_ref) {
    var item = _ref.item,
        key = _ref.key,
        animation = _ref.props;

    if (!item) {
      return null;
    }

    return (0, _core.jsx)(_Popper["default"], (0, _extends2["default"])({}, PopperProps, {
      open: true,
      key: key,
      anchorRef: anchorRef || defaultAnchorRef,
      anchorOrigin: anchorOrigin,
      popperOrigin: popperOrigin
    }), (0, _core.jsx)(_reactSpring.animated.div, {
      style: animation,
      css: fullHeight && classes.fullHeight
    }, (0, _core.jsx)(_Drawer["default"], {
      color: color,
      borderColor: borderColor,
      elevation: elevation,
      position: position,
      className: className,
      style: style
    }, children)));
  }));
};

__signature__(SlideableDrawer, "useStyles{classes}\nuseLazyRef{defaultAnchorRef}\nuseAppearTransition{transition}\nusePosition{anchorOrigin}\nusePosition{popperOrigin}", function () {
  return [useStyles, _useLazyRef["default"], _useAppearTransition["default"], usePosition, usePosition];
});

var _default = SlideableDrawer;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/index.tsx");
  reactHotLoader.register(usePosition, "usePosition", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/index.tsx");
  reactHotLoader.register(SlideableDrawer, "SlideableDrawer", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();